import { getDeviceWidth } from '../../listings-client/util/displayHelpers'

class ClientGlobals {
  constructor() {
    this._initialDeviceWidth = null
  }

  get initialDeviceWidth() {
    if (this._initialDeviceWidth === null) {
      this._initialDeviceWidth = getDeviceWidth()
    }
    return this._initialDeviceWidth
  }
}

const instance = new ClientGlobals()
export { instance as ClientGlobals }
